import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'
import firebase from 'firebase'

import MyIdeas from './pages/MyIdeas'
import Login from './components/Login.vue'
import Signup from './components/Signup.vue'
import MyLists from './pages/MyLists'
import Evaluate from './pages/Evaluate'
import ListPage from './pages/ListPage'
import ListEvaluate from './pages/ListEvaluate'
import Profile from './pages/Profile'
import PageNotFound from './components/shared/PageNotFound'
import Landing from './pages/Landing'
import WelcomeToList from "./pages/WelcomeToList"

import { pages } from '@/config/pagesConfig'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Landing,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/ideas',
        component: MyIdeas,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lists',
        component: MyLists,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/evaluate',
        component: Evaluate,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lists/:id',
        component: ListPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lists/:id/evaluate',
        component: ListEvaluate,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/profile',
        component: Profile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        component: Login,
        meta: {
            requiresAuth: false
        },
        beforeEnter: async (to, from, next) => {
            if(await firebase.getCurrentUser()) {
                next("/ideas")
            } else {
                next()
            }
        }
    },
    {
        path: '/signup',
        component: Signup,
        meta: {
            requiresAuth: false
        },
        beforeEnter: async (to, from, next) => {
            if(await firebase.getCurrentUser()) {
                next("/ideas")
            } else {
                next()
            }
        }
    },
    {
        path: '/welcometolist/:listIdEncoded',
        component: WelcomeToList,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: "*",
        component: PageNotFound,
        meta: {
            requiresAuth: true
        }
    }
];

let router = new VueRouter({ routes, mode: 'hash' });

router.beforeEach(async (to, from, next) => {
    if(to.fullPath === "/") {
        if (await firebase.getCurrentUser()) {
            next("/ideas");
        } else {
            next();
        }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!await firebase.getCurrentUser()) {
            next("/login")
        } else {            
            next() // go to wherever I'm going
        }
    } else {
        next() // does not require auth, make sure to always call next()!
    }
})

//On tab change
var currentPages = store.state.pages;
if (!currentPages) {
    currentPages = pages;
}

var isSubpath = function (from, to) {
    return to.startsWith(from);
}
router.afterEach((to, from) => {
    let isChanged = false;
    for (let i = 0, len = currentPages.length; i < len; i++) {
        if (currentPages[i].path === to.path) {
            currentPages[i].isActive = true;
            isChanged = true;
        } else if (isSubpath(currentPages[i].path, to.path)) {
            currentPages[i].isActive = true;
            isChanged = true;
        } else if (currentPages[i].path === from.path) {
            currentPages[i].isActive = false;
            isChanged = true;
        } else if (isSubpath(currentPages[i].path, from.path)) {
            currentPages[i].isActive = false;
            isChanged = true;
        }
    }
    if (isChanged) {
        store.dispatch('fetchPages', currentPages);
    }
});

export default router